/* unplugin-vue-components disabled */import __unplugin_components_0 from 'D:/htdocs/gitlab_project/laravel/mukiPailung/frontend/src/components/Menu.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "popup popup-tablet-fullscreen popup-crop_picture"
};
const _hoisted_2 = {
  class: "view"
};
const _hoisted_3 = {
  class: "page"
};
const _hoisted_4 = {
  class: "navbar text-color-white border-color-gray"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "navbar-bg"
}, null, -1);
const _hoisted_6 = {
  class: "navbar-inner"
};
const _hoisted_7 = {
  class: "left"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon-angle-left"
}, null, -1);
const _hoisted_9 = {
  class: "page-content"
};
const _hoisted_10 = {
  class: "page-content-inner"
};
const _hoisted_11 = {
  class: "page-inner"
};
const _hoisted_12 = {
  class: "crop_picture_block"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("input", {
  type: "file",
  id: "crop_picture_file",
  accept: "image/jpg,image/jpeg,image/png",
  style: {
    "display": "none"
  }
}, null, -1);
const _hoisted_14 = {
  class: "crop_picture_wrap",
  id: "crop_picture_select_trigger"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "form-group",
  id: "crop_picture_select_group"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "common_preview",
  id: "crop_picture_preview"
})], -1);
const _hoisted_16 = {
  type: "button",
  id: "crop_picture_select_btn",
  class: "bg-theme"
};
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"explain-wrap\"><h3 class=\"crop_picture_title text-theme\">建議尺寸：<span id=\"crop_picture_pic_size\"></span></h3><small class=\"crop_picture_tip\">可視範圍即為預覽效果<br>移動位置以拖曳方式操作</small></div><div class=\"crop_picture-btn-wrap\"><div class=\"row\"><div class=\"col-50\"><button type=\"button\" id=\"crop_picture_upload_btn\" class=\"col button btn-gt-theme size-h-45px\">上傳圖片</button></div><div class=\"col-50\"><button data-deg=\"90\" type=\"button\" id=\"crop_picture_rotate_btn\" class=\"col button btn-gt-theme size-h-45px\"><i class=\"btn-before fa fa-repeat btn-icon\" aria-hidden=\"true\"></i> 旋轉圖片 </button></div></div></div><div class=\"v-spacer-30px\"></div>", 3);
const _hoisted_20 = {
  class: "popup popup-tablet-fullscreen popup-sty-modal",
  id: "popup-sty-modal-default"
};
const _hoisted_21 = {
  class: "view"
};
const _hoisted_22 = {
  class: "page"
};
const _hoisted_23 = {
  class: "navbar"
};
const _hoisted_24 = {
  class: "navbar-inner"
};
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, null, -1);
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, null, -1);
const _hoisted_27 = {
  class: "right"
};
const _hoisted_28 = {
  class: "link popup-close popup-close-auto"
};
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content popup-modal-centered"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "page-inner"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "popup-modal-content no-bg"
})])], -1);
import { f7ready } from 'framework7-vue/bundle';
import routes from "@/js/routes.js";
import store from "@/store/store.js";
import { useI18n } from "vue-i18n";

// 除錯用

export default {
  __name: 'App',
  setup(__props) {
    if (process.env.NODE_ENV === 'development') {
      window.store = store;
    }

    // ==== 模組 ====

    // 手機原生虛擬返回鍵綁定
    function indexBackAction() {
      muki_back_action(2, function () {
        backPage();
      });
    }
    function inpageBackAction() {
      muki_back_action(1, function () {
        backPage();
      });
    }
    onMounted(() => {
      f7ready(() => {
        // Option 1. Using one 'page:init' handler for all pages
        $$(document).on('page:beforein', function (e) {
          if (f7.view.current.router.currentRoute.path == '/') {
            indexBackAction();
          } else {
            inpageBackAction();
          }
        });
      });
    });
    indexBackAction();

    // 取得全域 locale 實體
    const {
      t,
      locale
    } = useI18n();
    locale.value = localStorage.getItem("MukiLang") || mukiConst.locale['TW'];
    onMounted(() => {
      document.body.classList = '';
      document.body.classList.add(locale.value);
    });
    watch(locale, val => {
      document.body.classList = '';
      document.body.classList.add(val);
    });

    // Framework7 Parameters
    const f7params = {
      name: "pailung",
      // App name
      theme: "ios",
      // Automatic theme detection
      // App store
      store: store,
      // App routes
      routes: routes,
      navbar: {
        iosCenterTitle: true,
        mdCenterTitle: true,
        auroraCenterTitle: true
      },
      view: {
        // 打開 broweerHistory 在需要back page時可能會有問題
        // 故僅用於開發
        browserHistory: process.env.NODE_ENV === 'development' ? true : false,
        xhrCache: false
      },
      photoBrowser: {
        theme: 'dark',
        popupCloseLinkText: t('photoBrowser.bannerPhotoBrowser')
      },
      dialog: {
        buttonOk: t('dialog.buttonOk'),
        buttonCancel: t('dialog.buttonCancel')
      },
      colors: {
        primary: '#6BC0BF',
        orange: '#FF6F00',
        blue: '#10A1D6',
        purple: '#746FEE',
        gray: '#808080',
        green: '#00C100'
      }
    };

    // 自動計算基礎px
    const computeRatioOfBaseSize = () => {
      const initSize = 14;
      const htmlEl = document.querySelector("html");
      const windowWidth = htmlEl.clientWidth > 768 ? 768 : htmlEl.clientWidth;
      let baseSize = Number(windowWidth) / 375 * initSize;
      if (baseSize > 16) baseSize = 16;
      if (baseSize < 14) baseSize = 14;
      document.documentElement.style.setProperty('--f7-font-size', baseSize + 'px');
      htmlEl.style.fontSize = baseSize + "px";
    };
    function updateViewSizeAttr() {
      document.documentElement.style.setProperty('--view-width', $('#app').width() + 'px');
    }

    // 滑動偵測
    const ScrollDetect = function () {
      $$(document).on('page:afterin', function (e, page) {
        $('body').removeClass('is-scrolling');
        $('.view-main .page-content').on('scroll', e => {
          if (e.target.scrollTop > 20) {
            $('body').addClass('is-scrolling');
          } else {
            $('body').removeClass('is-scrolling');
          }
        });
      });
      $('.view-main .page-content').on('scroll', e => {
        if (e.target.scrollTop > 20) {
          $('body').addClass('is-scrolling');
        } else {
          $('body').removeClass('is-scrolling');
        }
      });
    };

    // 更新語系調整 系統提示文字
    const globalLocale = computed(() => {
      return store.state.locale;
    });
    watch(globalLocale, val => {
      f7.params.dialog.buttonOk = t('dialog.buttonOk');
      f7.params.dialog.buttonCancel = t('dialog.buttonCancel');
    });

    // currentPath
    const currentPath = ref(null);
    const photoRef = ref();
    const photos = reactive({
      list: []
    });
    const openPhotoBrowser = val => {
      photoRef.value.open(val);
    };
    onMounted(() => {
      // computeRatioOfBaseSize();
      updateViewSizeAttr();
      // window.addEventListener("resize", computeRatioOfBaseSize);
      window.addEventListener("resize", updateViewSizeAttr);
      ScrollDetect();

      // 點圖片開啟圖片顯示器
      window.addEventListener('click', e => {
        if (!e.target) return;
        const el = e.target.closest('.info-popup img');
        if (el) {
          const popup = e.target.closest('.info-popup');
          const photosImg = popup.querySelectorAll('img');
          let photosList = [];
          photosImg.forEach(img => {
            photosList.push(img.src);
          });
          photos.list = photosList;
          let index = -1;
          for (let i = 0; i < photosImg.length; ++i) {
            if (photosImg[i] === e.target) {
              index = i;
            }
          }
          if (index >= 0) {
            nextTick(() => {
              openPhotoBrowser(index);
            });
          }
        }
      });

      // ==== PAGE BEFORE IN 頁面事件 ====
      $$(document).on('page:beforein', function (e, page) {
        if (f7.view.current) {
          var toolbarPath = f7.view.current.router.currentRoute.path;
          currentPath.value = toolbarPath;
        }
      });
    });
    return (_ctx, _cache) => {
      const _component_f7_view = _resolveComponent("f7-view");
      const _component_Menu = __unplugin_components_0;
      const _component_f7_app = _resolveComponent("f7-app");
      const _component_f7_link = _resolveComponent("f7-link");
      const _component_f7_icon = _resolveComponent("f7-icon");
      const _component_f7_photo_browser = _resolveComponent("f7-photo-browser");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_f7_app, _normalizeProps(_guardReactiveProps(f7params)), {
        default: _withCtx(() => [_createVNode(_component_f7_view, {
          main: "",
          class: "safe-areas",
          url: "/"
        }), _createVNode(_component_Menu)]),
        _: 1
      }, 16), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_f7_link, {
        class: "",
        "popup-close": ""
      }, {
        default: _withCtx(() => [_hoisted_8]),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("button", _hoisted_16, [_createVNode(_component_f7_icon, {
        f7: "camera_fill"
      })])]), _hoisted_17])])])])])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _hoisted_26, _createElementVNode("div", _hoisted_27, [_createElementVNode("a", _hoisted_28, [_createVNode(_component_f7_icon, {
        f7: "multiply"
      })])])])]), _hoisted_29])])]), _createVNode(_component_f7_photo_browser, {
        "swipe-to-close": false,
        ref_key: "photoRef",
        ref: photoRef,
        photos: _unref(photos).list
      }, null, 8, ["photos"])], 64);
    };
  }
};